import styled from 'styled-components';

export const LoadMoreBtnContainer = styled.div`
  max-width: 904px;
`;
